import { updateUriRef } from '../../actions/filterActions';
import { QP_PAGE } from '../../constants/queryParamConstants';
import get from 'lodash.get';

export function getAppliedFilterValues({ appliedFilter, isBatchApplied }) {
    return isBatchApplied ? appliedFilter.values.slice(0, 1) : appliedFilter.values;
}

export function closeAppliedFilterHandler(dispatch) {
    return function({ filterName, filterValue, generatedUriRef, isBatchApplied }) {
        const [segments, queryParams] = generatedUriRef ? generatedUriRef.split('?') : [];
        const searchParams = generatedUriRef ? new URLSearchParams(queryParams) : null;

        if (isBatchApplied && searchParams.has(filterName)) {
            searchParams.delete(QP_PAGE);
            searchParams.delete(filterName);
            dispatch(
                updateUriRef({
                    filterName,
                    filterValue,
                    uriRef: `${segments}?${decodeURIComponent(searchParams.toString())}`,
                    isDeselected: true,
                })
            );
        } else {
            dispatch(
                updateUriRef({
                    filterName,
                    filterValue,
                    isDeselected: true,
                })
            );
        }
    };
}

export function clearAllAppliedFiltersHandler(dispatch, props) {
    return function() {
        const clearAppliedFiltersLinkReference = get(
            props,
            'itemSearch.clearAppliedFiltersLinkReference'
        );

        dispatch(
            updateUriRef({
                filterValue: { linkReference: clearAppliedFiltersLinkReference },
            })
        );
    };
}
